import React, { Component } from "react";
import "antd/dist/antd.css";
import { Form, Input, Button, Icon } from "antd";
import { Row, Col } from "antd";
import Uploaded from "../../Images/uploaded.png";
import Uploadlisting from "../../Images/uploadlisting.png";
import {
  updateCustomerOrCarrierDetails,
  getCustomerOrCarrierDetails,
} from "../../api/OraganizationApis";
import { Link } from "react-router-dom";
import { DeleteFilled } from "@ant-design/icons";
import LocationAutocomplete from "../../Components/Autocomplete";

let id = 0;
class customerLocations extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      latLangs: {},
    };
  }
  remove = (k) => {
    const { form } = this.props;
    const keys = form.getFieldValue("keys");
    if (keys.length === 0) {
      return;
    }
    form.setFieldsValue({
      keys: keys.filter((key) => key !== k),
    });
  };
  add = () => {
    const { form } = this.props;
    const keys = form.getFieldValue("keys");
    const nextKeys = keys.concat(id++);
    form.setFieldsValue({
      keys: nextKeys,
    });
  };
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.setState({
          loading: true,
        });
        let locationsData = [];
        if (
          values["keys"].length > 0 &&
          (!values["LocationName2"] ||
            !values["LocationName3"] ||
            !values["Address2"] ||
            !values["Address3"])
        ) {
          alert("Please fill in all information.");
          this.setState({
            loading: false,
          });
          return;
        }
        if (
          (!values["LocationName2"] && values["Address2"]) ||
          (values["LocationName2"] && !values["Address2"])
        ) {
          alert("Please fill location name and address.");
          this.setState({
            loading: false,
          });
          return;
        }
        if (
          (!values["LocationName3"] && values["Address3"]) ||
          (values["LocationName3"] && !values["Address3"])
        ) {
          alert("Please fill location name and address.");
          this.setState({
            loading: false,
          });
          return;
        }
        locationsData.push({
          location: values["LocationName1"],
          address: values["Address1"],
          city: null,
          state: null,
          latLng: this.state.latLangs["Address1"],
        });
        if (values["LocationName2"] && values["Address2"]) {
          locationsData.push({
            location: values["LocationName2"],
            address: values["Address2"],
            city: null,
            state: null,
            latLng: this.state.latLangs["Address2"],
          });
        }
        if (values["LocationName3"] && values["Address3"]) {
          locationsData.push({
            location: values["LocationName3"],
            address: values["Address3"],
            city: null,
            state: null,
            latLng: this.state.latLangs["Address3"],
          });
        }
        values["keys"].map((key) => {
          return locationsData.push({
            location: values[key + "LocationName"],
            address: values[key + "Address"],
            city: null,
            state: null,
            latLng: this.state.latLangs["Address1"],
          });
        });
        let orgDetails = JSON.parse(localStorage.getItem("orgDetails"));
        let data = {
          entityData: {
            customerLocations: locationsData,
          },
        };
        updateCustomerOrCarrierDetails(orgDetails["id"], data).then(
          (result) => {
            if (result.success) {
              getCustomerOrCarrierDetails(orgDetails["id"]).then((result) => {
                if (result.success) {
                  localStorage.setItem(
                    "orgDetails",
                    JSON.stringify(result.data)
                  );
                  // this.props.history.push('/app/stones');
                  this.props.history.push("/app/customerProducts");
                }
              });
            } else {
              console.log(result.errors);
            }
          }
        );
      }
    });
  };

  getAddress = (address, latLng, id) => {
    this.props.form.setFieldsValue({
      [id]: address,
    });
    let latLangs = this.state.latLangs;
    latLangs[id] = latLng;
    this.setState({
      latLangs,
    });
  };

  render() {
    const { getFieldDecorator, getFieldValue } = this.props.form;
    const formItemLayoutWithOutLabel = {
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 24 },
      },
    };
    getFieldDecorator("keys", { initialValue: [] });
    const keys = getFieldValue("keys");
    const formItems = keys.map((k, index) => (
      <Row style={{ flexDirection: "row", justifyContent: "center" }}>
        <Col span={8}>
          <Form.Item
            label={<span style={{ color: "#7B8190" }}>Location Name</span>}
            required={false}
            key={k}
          >
            {getFieldDecorator(k + "LocationName", {
              validateTrigger: ["onChange", "onBlur"],
              initialValue: "",
              rules: [
                {
                  required: true,
                  whitespace: true,
                  message: "Please input Location Name or delete this field.",
                },
              ],
            })(<Input placeholder="Location Name" style={{ width: "95%" }} />)}
          </Form.Item>
        </Col>
        <Col span={7} style={{ marginLeft: "10px" }}>
          <Form.Item
            label={<span style={{ color: "#7B8190" }}>Address</span>}
            required={false}
            key={k}
          >
            {getFieldDecorator(k + "Address", {
              validateTrigger: ["onChange", "onBlur"],
              initialValue: "",
              rules: [
                {
                  required: true,
                  whitespace: true,
                  message: "Please input Address or delete this field.",
                },
              ],
            })(
              <div style={{ width: "95%" }}>
                <LocationAutocomplete
                  getAddress={(address, latLng) =>
                    this.getAddress(address, latLng, k + "Address")
                  }
                  editMode={false}
                />
              </div>
            )}
          </Form.Item>
        </Col>
        {/* <Col span ={5}>
          <Form.Item label={<span style={{color:'#7B8190'}}>City</span>}
           required={false} key={k} >
           {getFieldDecorator(k+'City', {
            validateTrigger: ['onChange', 'onBlur'],
            initialValue:'',
            rules: [
              {
              required: true,
              whitespace: true,
              message: "Please input City or delete this field.",
              },
            ],
            })(<Input placeholder="City" style={{ width: '95%'}} />)}
        
          </Form.Item>
        </Col>
        <Col span ={3}>
        <Form.Item label={<span style={{color:'#7B8190'}}>State</span>}
           required={false} key={k} >
           {getFieldDecorator(k+'State', {
            validateTrigger: ['onChange', 'onBlur'],
            rules: [
              {
              required: true,
              whitespace: true,
              message: "Please input State or delete this field.",
              },
            ],
            })(<Select 
                // onChange={this.handleFilter}
                showSearch
                label={<span style={{color:'#0E4D90'}}>State</span>} 
                placeholder={"State"}
                defaultValue={"State"}
                style={{ width: '95%'}} 
              >
                { statesData.map(stateInfo => (
                  <Option key={ stateInfo.stateCode }>{ stateInfo.stateName }</Option>
                ))}
              </Select>)}
        
          </Form.Item>
        </Col> */}
        <Col span={1} style={{ marginTop: "35px", marginBottom: "auto" }}>
          {keys.length > 0 ? (
            <DeleteFilled
              style={{ color: "#0e4d90", fontSize: "1.2em", marginTop: "12px" }}
              title="Remove"
              // className="dynamic-delete-button"
              // type="minus-circle-o"
              onClick={() => this.remove(k)}
            />
          ) : null}
        </Col>
      </Row>
    ));

    return (
      <div>
        <div className="Docdiv">
          <h3
            className="Docheading"
            style={{ fontSize: "30px", lineHeight: "30px" }}
          >
            Locations
          </h3>
          <p className="Docpara" style={{ fontSize: "17px", color: "#7B8190" }}>
            Please upload your locations. At least one is required.
          </p>
          <Row type="flex" justify="start">
            <Col span={6} className="DocumentsCol">
              <div className="DocumentDivUnselect">
                <img src={Uploaded} className="Circle" alt="Upload icon" />
                <h3>Documents</h3>
              </div>
              <div className="DocumentDivSelect">
                <img src={Uploadlisting} className="Circle" alt="Upload icon" />
                <h3>Locations</h3>
              </div>
              <div className="DocumentDivUnselect">
                <img src={Uploadlisting} className="Circle" alt="Upload icon" />
                <h3>Products</h3>
              </div>
            </Col>
            <Col
              span={16}
              style={{
                backgroundColor: "white",
                minHeight: "400px",
                borderRadius: "10px",
                padding: "40px",
              }}
            >
              <div>
                <h3>Locations</h3>
                <p style={{ fontSize: "17px", color: "#7B8190" }}>
                  We need at least one location added for your registration to
                  be processed.
                </p>
                <p style={{ fontSize: "20px", color: "#7B8190" }}>
                  I'm uploading:
                </p>
                <div>
                  <Form onSubmit={this.handleSubmit}>
                    <Row>
                      <Col span={8}>
                        <Form.Item
                          className="Formitem"
                          label={
                            <span style={{ color: "#0E4D90" }}>
                              Location Name
                            </span>
                          }
                        >
                          {getFieldDecorator("LocationName1", {
                            initialValue: "",
                            rules: [
                              {
                                required: true,
                                message: "Please input your Location Name",
                              },
                            ],
                          })(<Input />)}
                        </Form.Item>
                      </Col>
                      <Col span={8} style={{ marginLeft: "10px" }}>
                        <Form.Item
                          className="Formitem"
                          label={
                            <span style={{ color: "#0E4D90" }}>Address</span>
                          }
                        >
                          {getFieldDecorator("Address1", {
                            initialValue: "",
                            rules: [
                              {
                                required: true,
                                message: "Please input your Address",
                              },
                            ],
                          })(
                            <LocationAutocomplete
                              getAddress={(address, latLng) =>
                                this.getAddress(address, latLng, "Address1")
                              }
                              editMode={false}
                            />
                          )}
                        </Form.Item>
                      </Col>
                      {/* <Col span={5}>
                    <Form.Item className="Formitem" 
                      label={<span style={{color:'#0E4D90'}}>City</span>} >
                      {getFieldDecorator('City1', {
                        initialValue:'',
                      rules: [{required: true,  message: 'Please input your City' }],
                      })(<Input />)}
                    </Form.Item>
                  </Col>
                  <Col span={3}>
                  <Form.Item className="Formitem" 
                      label={<span style={{color:'#0E4D90'}}>State</span>} >
                      {getFieldDecorator('State1', {
                      rules: [{required: true,  message: 'Please input your State' }],
                      })(<Select 
                        // onChange={this.handleFilter}
                        showSearch
                        label={<span style={{color:'#0E4D90'}}>State</span>} 
                        placeholder={"State"}
                        initialValue={"State"}
                      >
                        { statesData.map(stateInfo => (
                          <Option key={ stateInfo.stateCode }>{ stateInfo.stateName }</Option>
                        ))}
                      </Select>)}
                    </Form.Item>
                  </Col> */}
                    </Row>
                    <Row>
                      <Col span={8}>
                        <Form.Item
                          className="Formitem"
                          label={
                            <span style={{ color: "#0E4D90" }}>
                              Location Name
                            </span>
                          }
                        >
                          {getFieldDecorator("LocationName2", {
                            initialValue: "",
                            rules: [
                              { message: "Please input your Location Name" },
                            ],
                          })(<Input />)}
                        </Form.Item>
                      </Col>
                      <Col span={8} style={{ marginLeft: "10px" }}>
                        <Form.Item
                          className="Formitem"
                          label={
                            <span style={{ color: "#0E4D90" }}>Address</span>
                          }
                        >
                          {getFieldDecorator("Address2", {
                            initialValue: "",
                            rules: [{ message: "Please input your Address" }],
                          })(
                            <LocationAutocomplete
                              getAddress={(address, latLng) =>
                                this.getAddress(address, latLng, "Address2")
                              }
                              editMode={false}
                            />
                          )}
                        </Form.Item>
                      </Col>
                      {/* <Col span={5}>
                    <Form.Item className="Formitem" 
                      label={<span style={{color:'#0E4D90'}}>City</span>} >
                      {getFieldDecorator('City2', {
                        initialValue:'',
                      rules: [{  message: 'Please input your City' }],
                      })(<Input  />)}
                    </Form.Item>
                  </Col>
                  <Col span={3}>
                  <Form.Item className="Formitem" 
                      label={<span style={{color:'#0E4D90'}}>State</span>} >
                      {getFieldDecorator('State2', {
                      rules: [{  message: 'Please input your State' }],
                      })(<Select 
                        // onChange={this.handleFilter}
                        showSearch
                        label={<span style={{color:'#0E4D90'}}>State</span>} 
                        placeholder={"State"}
                        initialValue={"State"}
                      >
                      </Select>)}
                    </Form.Item>
                  </Col> */}
                    </Row>
                    <Row>
                      <Col span={8}>
                        <Form.Item
                          className="Formitem"
                          label={
                            <span style={{ color: "#0E4D90" }}>
                              Location Name
                            </span>
                          }
                        >
                          {getFieldDecorator("LocationName3", {
                            initialValue: "",
                            rules: [
                              { message: "Please input your Location Name" },
                            ],
                          })(<Input />)}
                        </Form.Item>
                      </Col>
                      <Col span={8} style={{ marginLeft: "10px" }}>
                        <Form.Item
                          className="Formitem"
                          label={
                            <span style={{ color: "#0E4D90" }}>Address</span>
                          }
                        >
                          {getFieldDecorator("Address3", {
                            initialValue: "",
                            rules: [{ message: "Please input your Address" }],
                          })(
                            <LocationAutocomplete
                              getAddress={(address, latLng) =>
                                this.getAddress(address, latLng, "Address3")
                              }
                              editMode={false}
                            />
                          )}
                        </Form.Item>
                      </Col>
                      {/* <Col span={5}>
                    <Form.Item className="Formitem" 
                      label={<span style={{color:'#0E4D90'}}>City</span>} >
                      {getFieldDecorator('City3', {
                        initialValue:'',
                      rules: [{  message: 'Please input your City' }],
                      })(<Input />)}
                    </Form.Item>
                  </Col>
                  <Col span={3}>
                  <Form.Item className="Formitem" 
                      label={<span style={{color:'#0E4D90'}}>State</span>} >
                      {getFieldDecorator('State3', {
                      rules: [{  message: 'Please input your State' }],
                      })(<Select 
                        // onChange={this.handleFilter}
                        showSearch
                        label={<span style={{color:'#0E4D90'}}>State</span>} 
                        placeholder={"State"}
                        initialValue={"State"}
                      >
                      </Select>)}
                    </Form.Item>
                      
                      
                    
                  </Col> */}
                    </Row>
                    {formItems}
                    <Form.Item {...formItemLayoutWithOutLabel}>
                      <Button
                        type="dashed"
                        style={{
                          textAlign: "center",
                          backgroundColor: "#0E4D90",
                          width: "16px",
                          borderRadius: "50%",
                          borderColor: "#0E4D90",
                          padding: "0px",
                          height: "16px",
                        }}
                      >
                        <Link onClick={this.add}>
                          <Icon
                            type="plus"
                            style={{
                              verticalAlign: "0px",
                              fontSize: "14px",
                              color: "white",
                            }}
                          />
                          <span
                            style={{
                              marginLeft: "7px",
                              color: "#0E4D90",
                              lineHeight: "20px",
                            }}
                          >
                            Add Location
                          </span>
                        </Link>
                      </Button>
                    </Form.Item>
                    <Form.Item
                      {...formItemLayoutWithOutLabel}
                      style={{ textAlign: "center" }}
                    >
                      <Button
                        type="primary"
                        htmlType="submit"
                        loading={this.state.loading}
                        className="truckSubmit"
                      >
                        Submit
                      </Button>
                    </Form.Item>
                  </Form>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}
export default Form.create({ name: "customerLocations" })(customerLocations);
